export default __webpack_public_path__ + "4df6cee262fa99d7a6dd4bccd9afa69b.svg";